import React from 'react';

import {MegaHeaderModuleProps} from "../models/mega-header-module.props";
import {ACTION_TYPES} from "../../../../../core/consts";
import {MegaHeaderModuleLogo} from "./mega-header-module.logo";
import {APP} from "../../../../../core/app/consts";
import {Link} from "../../../../../core/components/link/link";
import {observer} from "mobx-react";
import {FollowSelection} from "../../../../../core/components/entity-selection/follow-selection/follow-selection";
import {MEGA_HEADER_MODULE} from "../mega-header-module.consts";
import {Tooltip} from "../../../../../core/components/tooltip/tooltip";
import {TOOLTIP_PLACEMENT} from "../../../../../core/components/tooltip/tooltip-consts";
import {NavigationTabsModuleAsync} from "../../../../../modules/navigation-tabs-module/components/navigation-tabs-module.async";
import {useThemeColor} from "../../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../../../core/app/consts/colors";

export class MegaHeaderModuleDesktopContentProps extends MegaHeaderModuleProps {}

export const MegaHeaderModuleDesktopContent = observer(({controller}: MegaHeaderModuleDesktopContentProps) => {
  const {state} = controller;
  const {device, selectedEntity, headerModel, isGameRoute} = state;

  const logoProps = {
    device: device,
    entity: selectedEntity,
    style: {
      width: 'auto',
      height: 68
    },
    containerStyle: {
      width: 98,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '0 6px',
    },
    eager: true,
    alt: selectedEntity?.name
  }

  const followProps = {
    color: useThemeColor(COLORS.textSecondary),
    size: MEGA_HEADER_MODULE.POPULARITY_ICON_SIZE,
    descriptionEntity: selectedEntity,
    containerClassName: 'mega-header-module-entity-follow-container',
    followClassName: 'mega-header-module-entity-follow-button',
    followActiveClassName: 'mega-header-module-entity-follow-active-button',
    popularityClassName: 'mega-header-module-entity-follow-popularity',
  }

  const onEntityClick = () => {
    controller.action(ACTION_TYPES.entityClick, {
      entityId: headerModel?.id,
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[headerModel?.entityVM?.objectType],
      source: APP.ANALYTICS.SOURCES[state.currentLinkModel?.name],
      currentLinkModel: state.currentLinkModel?.name,
      sportTypeId: headerModel?.entityVM?.sport.id
    });

    return true;
  }

  const linkProps = {
    model: state.currentRefreshLinkModel,
    onClick: () => onEntityClick()
  }

  const logoLinkProps = {
    model: state.refreshLinkModel,
    onClick: () => onEntityClick()
  }

  const tooltipProps = {
    title: state.websiteModuleState.pageMetadata.entity?.description,
    placement: device.isRtl ? TOOLTIP_PLACEMENT.bottomStart : TOOLTIP_PLACEMENT.bottomEnd,
    maxWidth: MEGA_HEADER_MODULE.DESCRIPTION_TOOLTIP_WIDTH,
  }

  const TitleTag = isGameRoute ? 'h2' : 'h1';

  return (
    <>
      <>
        <Link {...logoLinkProps} style={{width: 110}}>
          {
            headerModel ?
              <MegaHeaderModuleLogo {...logoProps} /> : null
          }
        </Link>
      </>
      <>
        <div className={'mega-header-module-content'}>
          <div className={'mega-header-module-entity'}>
            <div className={'mega-header-module-entity-container'}>
              <Tooltip {...tooltipProps}>
                <Link {...linkProps}>
                  <TitleTag className={['mega-header-module-entity-name'].join(' ')}>
                    {state.mainTitle}
                  </TitleTag>
                </Link>
              </Tooltip>
              {
                headerModel ? <FollowSelection {...followProps}/> : null
              }
            </div>
          </div>
          <div className={'mega-header-module-buttons-container'}>
            {
              selectedEntity ? <NavigationTabsModuleAsync entity={selectedEntity}/> : null
            }
          </div>
        </div>
      </>
    </>
  );
});
